import { ApiConnection } from '../../decorators/@ApiConnection.decorator';
import { ExpenseService } from './expense.service';
import { DataSource } from "@angular/cdk/collections";
import { IApiExpense, IApiExpenseConnection, IApiExpenseFilter } from 'src/app/shared/modules/graphql/types/types';
import { NefcoPagedDataSource } from 'src/app/shared/helpers/nefco-data-source.class';

export class ExpenseDataSource extends NefcoPagedDataSource<IApiExpense, ExpenseService, IApiExpenseConnection> implements DataSource<IApiExpense> {
  @ApiConnection()
  public load(filters?: IApiExpenseFilter[]): Promise<IApiExpenseConnection> {
    return this.service.get(filters, this.listPage).toPromise();
  }
}